import { NavLink } from 'react-router-dom'
import { 
  HomeIcon,
  UsersIcon,
  TicketIcon,
  ChartBarIcon,
  Cog6ToothIcon,
  FilmIcon,
} from '@heroicons/react/24/outline'

const navigation = [
  { name: 'Dashboard', href: '/dashboard', icon: HomeIcon },
  { name: 'Users', href: '/users', icon: UsersIcon },
  { name: 'Creator Clips', href: '/creator-clips', icon: FilmIcon },
  { name: 'Promocodes', href: '/promocodes', icon: TicketIcon },
  { name: 'Analytics', href: '/analytics', icon: ChartBarIcon },
]

type SidebarContentProps = {
  onNavigate?: () => void
}

export function SidebarContent({ onNavigate }: SidebarContentProps) {
  return (
    <div className="flex flex-col flex-grow bg-white border-r border-gray-200 pt-6 pb-4 overflow-y-auto">
      <div className="flex items-center flex-shrink-0 px-6">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <div className="w-10 h-10 bg-gradient-to-br from-primary-500 to-primary-600 rounded-xl flex items-center justify-center shadow-lg">
              <Cog6ToothIcon className="w-6 h-6 text-white" />
            </div>
          </div>
          <div className="ml-3">
            <h1 className="text-lg font-bold text-gray-900">Cassette Admin</h1>
            <p className="text-xs text-gray-500">Console</p>
          </div>
        </div>
      </div>
      
      <div className="mt-8 flex-grow flex flex-col">
        <nav className="flex-1 px-2 space-y-1">
          {navigation.map((item) => (
            <NavLink
              key={item.name}
              to={item.href}
              onClick={onNavigate}
              className={({ isActive }) =>
                `group flex items-center px-3 py-3 text-sm font-medium rounded-xl transition-all duration-200 ${
                  isActive
                    ? 'bg-primary-50 text-primary-700 border-r-2 border-primary-600'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                }`
              }
            >
              <item.icon
                className="mr-3 flex-shrink-0 h-5 w-5"
                aria-hidden="true"
              />
              {item.name}
            </NavLink>
          ))}
        </nav>
      </div>
      
      <div className="flex-shrink-0 flex border-t border-gray-200 p-4">
        <div className="flex-shrink-0 w-full group block">
          <div className="flex items-center">
            <div className="ml-3">
              <p className="text-xs font-medium text-gray-500 group-hover:text-gray-700">
                Admin Console v1.0.0
              </p>
              <p className="text-xs text-gray-400 group-hover:text-gray-600">
                Secure Admin Access
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export function Sidebar() {
  return (
    <div className="hidden lg:fixed lg:inset-y-0 lg:flex lg:w-64 lg:flex-col">
      <SidebarContent />
    </div>
  )
}
